var _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgBilling = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33.000000pt",
    height: "33.000000pt",
    viewBox: "0 0 33.000000 33.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,33.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 307 l-38 -11 0 -148 c0 -145 1 -149 20 -144 11 3 29 9 40 12 19 5 20 14 20 155 0 82 -1 148 -2 148 -2 -1 -20 -6 -40 -12z",
    fill: "#484b52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 170 l0 -148 40 -10 40 -10 0 148 0 148 -40 10 -40 10 0 -148z",
    fill: "#484b52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268 308 l-28 -10 0 -148 0 -148 43 13 42 12 3 147 c3 161 4 158 -60 134z",
    fill: "#484b52"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBilling, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/billing.24c94b33.svg";
export { ForwardRef as ReactComponent };